/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var WalletOutlineIcon = function WalletOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M17 15C17 16.1046 16.1046 17 15 17C13.8954 17 13 16.1046 13 15C13 13.8954 13.8954 13 15 13C16.1046 13 17 13.8954 17 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.49998V8.31154C2 6.93493 2.93689 5.73498 4.27239 5.40111L15.2724 2.65111C17.1658 2.17775 19 3.60982 19 5.56154V7C20.6569 7 22 8.34315 22 10V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V8.49998C2 8.49999 2 8.49998 2 8.49998ZM15.7575 4.59139C16.3886 4.43361 17 4.91097 17 5.56154V7H6.12304L15.7575 4.59139ZM4 9V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V10C20 9.44772 19.5523 9 19 9H4Z"
  }));
};
export default WalletOutlineIcon;